import { GraphQLQueryClass } from "@bsm/component";
import { TSignatoriesResponse } from "@bsm/graphql";

export default class SignatoryListQuery
    implements GraphQLQueryClass<TSignatoriesResponse, TResponse>
{
    queryKey = "Invoce.Signatory.List.Query";
    
    gql = `
        query InvoiceSignatoryList {
            signatories {
                total
                data {
                    id
                    name
                    fonction
                    signature { id }
                }
            }
        }
    `;

    variables?: any;

    constructor(variables?: any) {
        this.variables = variables;
    }

    mapFn(data: TResponse): TSignatoriesResponse {
        return data.signatories;
    }
}

type TResponse = {
    signatories: TSignatoriesResponse;
};